module.exports = __webpack_public_path__ + "5d4fe1204f382dfb178508890caeeabe.png";